module.exports = __webpack_public_path__ + "static/media/01-Banque-Mondiale.b3dc7841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_banque-mondiale/01-Banque-Mondiale.jpg
// module id = 337
// module chunks = 37